import { InnerBlocks } from '@wordpress/block-editor';
import {GetIcon} from '@vayu-blocks';

const Layout = ({
  layout,
  isEvenIndex,
  isOddIndex,
  printedIcon,
  iconRef,
}) => {

  const timeline_child_template = React.useMemo(() => [
    [
      'vayu-blocks/advance-container',
      {
        className: 'vb-timeine-content',
        contFlex: {
          direction: {
            Desktop: 'start',
            Tablet: 'start',
            Mobile: 'start',
          },
          rwGap: {  
            Desktop: '0px',
            Tablet: '0px',
            Mobile: '0px',
          },
        },
        advBackground: {
          type: 'color',
          color: '#f1e3ff',
          image: {
              url: ''
          },
          gradient: 'linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2c5364 100%)'
        },
      },
      [
        [
          'vayu-blocks/advance-heading',
          {
            className: 'vb-timeine-content-heading',
            content: 'Timeline Child...',
            align: {
              Desktop: 'center',
              Tablet: 'center',
              Mobile: 'center',
            },
             typography : { 
              fonts: {},
              fontSize: {
                  Desktop: '20px',
                  Tablet: '20px',
                  Mobile: '20px'
              },
              appearance: {},
              lineHeights: {},
              letterSpacing: {},
              decoration: {},
              orientation: {},
              letterCase: {}
            }
          },
        ],
        [
          'core/paragraph',
          {
            className: 'vb-timeine-content-para',
            content:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce ullamcorper eget lorem nec sagittis.',
            style: { typography: { fontSize: '15px' } },
          },
        ],
      ],
    ],
    [
      'vayu-blocks/advance-container',
      {
        className: 'vb-timeline-date',
        contFlex: {
          direction: {
            Desktop: 'column',
            Tablet: 'column',
            Mobile: 'column',
          },
          rwGap: {
            Desktop: '0px',
            Tablet: '0px',
            Mobile: '0px',
          },
        },
      },
      [
        [
          'vayu-blocks/advance-heading',
          {
            className: 'vb-timeline-date-heading',
            content: '11 May, 2025',
            tag: 'span',
            align: {
              Desktop: 'center',
              Tablet: 'center',
              Mobile: 'center',
            },
            typography : { 
              fonts: {},
              fontSize: {
                  Desktop: '20px',
                  Tablet: '20px',
                  Mobile: '20px'
              },
              appearance: {},
              lineHeights: {},
              letterSpacing: {},
              decoration: {},
              orientation: {},
              letterCase: {}
            }
          },
        ],
      ],
    ],
  ], []);

  let layoutClassName = '';
  let innerLayoutClass = '';

  if (['layout-1', 'layout-2', 'layout-3', 'layout-4'].includes(layout)) {
    layoutClassName = 'vb-timeline-layout-main-1-4';
    if (
      layout === 'layout-2' ||
      (layout === 'layout-3' && isEvenIndex) ||
      (layout === 'layout-4' && isOddIndex)
    ) {
      layoutClassName += ' vb-direction-layout-2';
    }
    innerLayoutClass = 'vb-timeine-layout-1-4';
  }

  if (['layout-5', 'layout-6'].includes(layout)) {
    layoutClassName = 'vb-timeline-layout-main-5-6';
    if (layout === 'layout-5') {
      layoutClassName += ' vb-direction-layout-5';
    }
    innerLayoutClass = 'vb-timeine-layout-5-6';
  }

  if (['layout-7', 'layout-8'].includes(layout)) {
    layoutClassName = 'vb-timeline-layout-main-7-8';
    if (layout === 'layout-8') {
      layoutClassName += ' vb-timeline-layout-main-8';
    }
    innerLayoutClass = 'vb-timeine-layout-7-8';
  }

  if (['layout-11', 'layout-12'].includes(layout)) {
    layoutClassName = layout === 'layout-12'
      ? 'vb-timeline-layout-main-12'
      : 'vb-timeline-layout-main-11';
    innerLayoutClass = 'vb-timeine-layout-11';
  }

  return (
    <article className={layoutClassName}>
      <div className={innerLayoutClass}>
        <InnerBlocks template={timeline_child_template} />
      </div>

      <div className="vb-timeline-icon vayu_blocks-timeline__parent">
        <div
          ref={iconRef}
          className="vb-timeline-icon-marker vayu_blocks-timeline__marker"
        >

          <GetIcon
            value={printedIcon}
          />

        </div>
      </div>
    </article>
  );
 
};

export default Layout;
